import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarArtigosLayer from "../components/CadastrarArtigosLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarArtigosPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("artigo.breadcrumb")} />
      <CadastrarArtigosLayer />
    </MasterLayout>
  );
};

export default CadastrarArtigosPage;
